module.exports = __webpack_public_path__ + "img/uk-colorectal-cancer-female.d425a45e.png";